var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSquares(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1631,
    height: 766,
    viewBox: "0 0 1631 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0514FD"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1025 334.416L1263.88 220 1445 312.228 1206.68 432z",
    opacity: 0.153,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277 162.07L1515.887 48 1631 106.062 1396.605 221z",
    opacity: 0.2,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1429 241.276L1534.961 190 1567 207.855 1465.547 260z",
    opacity: 0.119,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085 111.927L1288.121 15 1386 64.336 1186.698 162z",
    opacity: 0.2,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 12L998.567 12 1085 52.565 808.271 197z",
    opacity: 0.163,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 436.51L270.856 406 332 438.121 272 468z",
    opacity: 0.114,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 374.51L270.856 344 332 376.121 272 406z",
    opacity: 0.2,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984 165.51L1042.856 135 1104 167.121 1044 197z",
    opacity: 0.103,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 497.579L445.539 378 684 503.896 450 621zM493 324.354L629.84 253 772 328.123 632.5 398zM141 715.206L236.5 667 332 715.997 237.26 766zM1386 405.206L1481.5 357 1577 405.997 1482.26 456z",
    opacity: 0.2,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331 481.755L1386 454 1441 482.21 1386.438 511z",
    opacity: 0.1,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885 564.348L1084.799 456 1283 557.953 1086.376 662zM0 101.994L237.526 0 543 144.635 303.161 260z",
    opacity: 0.2,
    transform: "translate(230 -250) matrix(1 0 0 -1 -230 1016)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSquares);
export default __webpack_public_path__ + "static/media/bg-squares.7ef5d2c4711428542dc2686666fcb89c.svg";
export { ForwardRef as ReactComponent };